import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=6e5f0c0a&scoped=true"
import script from "./base-dialog.vue?vue&type=script&lang=js"
export * from "./base-dialog.vue?vue&type=script&lang=js"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=6e5f0c0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f0c0a",
  null
  
)

export default component.exports